module.exports = __webpack_public_path__ + "static/media/why-us-nav-2.31f89b52.jpg";